const colors = {
  blackAlpha: {
    10: 'rgba(0, 0, 0, 0.01)',
    20: 'rgba(0, 0, 0, 0.02)',
  },
};

export default colors;
